export { UniformPreviewPageTemplate } from "./uniform-preview-page.template";
export { UniformPreviewPageTemplate as default } from "./uniform-preview-page.template";
